import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ActionButton from '../../../../Components/Common/ActionButton';
import {
  FormActions,
  FormField,
  FormGrid,
  SelectField,
} from '../../../../Components/Form';
import { RespondNotesEditor } from '../../../../shared/offer-domain/ui';

const ModalActions = ({ onCancel, onSave, saveLabel = 'Save' }) => (
  <FormActions>
    <ActionButton variant='secondary' icon='ri-close-line' onClick={onCancel}>
      Cancel
    </ActionButton>
    <ActionButton variant='primary' onClick={onSave}>
      {saveLabel}
    </ActionButton>
  </FormActions>
);

// A rich-text editor under the shared label / spacing.
const EditorField = ({ id, label, value, onChange }) => (
  <FormField label={label} name={id} id={id} span='full'>
    <RespondNotesEditor id={id} value={value || ''} onChange={onChange} />
  </FormField>
);

export const CounterPaymentTermsModal = ({
  isOpen,
  toggle,
  draft,
  onDraftChange,
  invoiceQuantityOptions = [],
  modeOptions = [],
  currencyOptions = [],
  onSave,
  isUpdate = false,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    centered
    size='lg'
    backdrop='static'
    scrollable
  >
    <ModalHeader toggle={toggle}>Counter Payment Terms</ModalHeader>
    <ModalBody>
      <FormGrid columns={3}>
        <SelectField
          label='Invoicing quantity'
          name='invoicingQuantityId'
          options={invoiceQuantityOptions}
          value={draft.invoicingQuantityId}
          onChange={value => onDraftChange('invoicingQuantityId', value ?? '')}
        />
        <SelectField
          label='Mode'
          name='modeInvoicingQuantityId'
          options={modeOptions}
          value={draft.modeInvoicingQuantityId}
          onChange={value =>
            onDraftChange('modeInvoicingQuantityId', value ?? '')
          }
        />
        <SelectField
          label='Currency'
          name='paymentCurrencyId'
          options={currencyOptions}
          value={draft.paymentCurrencyId}
          onChange={value => onDraftChange('paymentCurrencyId', value ?? '')}
        />
        <EditorField
          id='counterDescriptionOfPaymentTerms'
          label='Description of payment term'
          value={draft.descriptionOfPaymentTerms}
          onChange={e =>
            onDraftChange('descriptionOfPaymentTerms', e.target.value)
          }
        />
      </FormGrid>
      <ModalActions
        onCancel={toggle}
        onSave={onSave}
        saveLabel={isUpdate ? 'Update' : 'Save'}
      />
    </ModalBody>
  </Modal>
);

export const CounterComplianceModal = ({
  isOpen,
  toggle,
  draft,
  onDraftChange,
  lawOptions = [],
  arbitrationOptions = [],
  onSave,
  isUpdate = false,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    centered
    size='lg'
    backdrop='static'
    scrollable
  >
    <ModalHeader toggle={toggle}>Counter Compliance</ModalHeader>
    <ModalBody>
      <FormGrid columns={2}>
        <SelectField
          label='Law'
          name='lawId'
          options={lawOptions}
          value={draft.lawId}
          onChange={value => onDraftChange('lawId', value ?? '')}
        />
        <SelectField
          label='Arbitration'
          name='arbitrationId'
          options={arbitrationOptions}
          value={draft.arbitrationId}
          onChange={value => onDraftChange('arbitrationId', value ?? '')}
        />
        <EditorField
          id='counterOtherTermsAndCondition'
          label='Other terms and conditions'
          value={draft.otherTermsAndCondition}
          onChange={e =>
            onDraftChange('otherTermsAndCondition', e.target.value)
          }
        />
        <EditorField
          id='counterAdditionalNotes'
          label='Additional notes'
          value={draft.additionalNotes}
          onChange={e => onDraftChange('additionalNotes', e.target.value)}
        />
      </FormGrid>
      <ModalActions
        onCancel={toggle}
        onSave={onSave}
        saveLabel={isUpdate ? 'Update' : 'Save'}
      />
    </ModalBody>
  </Modal>
);
